import React, { useEffect, useState } from 'react';
import { NewNavbar, BreadCrumbsNew, NewFooter } from '../../components';
import Seo from '../../components/Seo';
import './simplyBookPage.css';

const WIDGET_SRC = 'https://widget.simplybook.it/v2/widget/widget.js';
const CONTAINER_ID = 'sb-booking-widget';

const BASE_CONFIG = {
  widget_type: 'iframe',
  url: 'https://privatechemist.simplybook.it',
  theme: 'simple_beauty_theme',
  theme_settings: {
    sb_base_color: '#202f32',
    header_color: '#ffffff',
    timeline_hide_unavailable: '1',
    hide_past_days: '0',
    timeline_show_end_time: '0',
    timeline_modern_display: 'as_slots',
    display_item_mode: 'block',
    body_bg_color: '#ffffff',
    sb_review_image: '',
    dark_font_color: '#000000',
    light_font_color: '#ffffff',
    btn_color_1: '#202f32',
    sb_company_label_color: '#000000',
    hide_img_mode: '1',
    show_sidebar: '1',
    sb_busy: '#c7b3b3',
    sb_available: '#e6e6e6',
  },
  timeline: 'modern',
  datepicker: 'top_calendar',
  is_rtl: false,
  app_config: {
    clear_session: 0,
    allow_switch_to_ada: 0,
  },
  container_id: CONTAINER_ID,
};

/**
 * Booking page with the SimplyBook widget, preset to one provider category.
 */
function SimplyBookPage({ title, slug, description, category }) {
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    const container = document.getElementById(CONTAINER_ID);
    const init = () => {
      if (!window.SimplybookWidget || !container) return;
      container.innerHTML = '';
      new window.SimplybookWidget({
        ...BASE_CONFIG,
        app_config: { ...BASE_CONFIG.app_config, predefined: { provider: '2', category } },
      });
      const iframe = container.querySelector('iframe');
      if (iframe) {
        iframe.addEventListener('load', () => setLoading(false), { once: true });
      } else {
        setLoading(false);
      }
    };

    const handleError = () => setLoadError(true);
    let script = document.querySelector(`script[src="${WIDGET_SRC}"]`);
    if (window.SimplybookWidget) {
      init();
    } else {
      if (!script) {
        script = document.createElement('script');
        script.src = WIDGET_SRC;
        script.async = true;
        document.body.appendChild(script);
      }
      script.addEventListener('load', init);
      script.addEventListener('error', handleError);
    }

    return () => {
      if (script) {
        script.removeEventListener('load', init);
        script.removeEventListener('error', handleError);
      }
      if (container) container.innerHTML = '';
    };
  }, [category]);

  return (
    <div className="sb-page">
      <Seo
        title={`${title} - My Private Chemist`}
        description={description}
        canonical={`${process.env.REACT_APP_BASE_URL}/${slug}`}
        url={`${process.env.REACT_APP_BASE_URL}/${slug}`}
        image={`${process.env.REACT_APP_BASE_URL}/logo.png`}
      />
      <div className="breadcrumnb-img-bg">
        <div className="container">
          <NewNavbar />
          <BreadCrumbsNew breadcrumbs={[{ label: 'Home', path: '/' }, { label: title }]} title={title} />
        </div>
      </div>

      <main className="sb-main">
        {loadError ? (
          <p className="sb-error">
            The booking calendar could not be loaded. Please refresh the page or contact us to book your appointment.
          </p>
        ) : (
          <div className={`sb-widget${loading ? ' is-loading' : ''}`}>
            {loading && (
              <div className="sb-loader" role="status" aria-label="Loading booking calendar">
                <span className="sb-spinner" />
              </div>
            )}
            <div id={CONTAINER_ID} />
          </div>
        )}
      </main>

      <NewFooter />
    </div>
  );
}

export default SimplyBookPage;
